// 1. Guard Clause: Scope everything to your specific container ID
const carouselContainer = document.getElementById('simple-carousel');

if (carouselContainer) {
  const innerTrack = carouselContainer.querySelector('.simple-carousel-inner');
  const items = carouselContainer.querySelectorAll('.simple-carousel-item');
  const totalSlides = items.length;

  const firstClone = items[0].cloneNode(true);
  const lastClone = items[totalSlides - 1].cloneNode(true);

  innerTrack.appendChild(firstClone);
  innerTrack.insertBefore(lastClone, items[0]);

  let currentTrackIndex = 1;
  let isTransitioning = false;

  innerTrack.style.transform = `translateX(-${currentTrackIndex * 100}%)`;

  function moveSlide(direction) {
    if (isTransitioning) return; // Prevent clicking spam during animation
    isTransitioning = true;

    // Enable smooth animation for the move
    innerTrack.style.transition = 'transform 0.4s ease-in-out';
    currentTrackIndex += direction;

    innerTrack.style.transform = `translateX(-${currentTrackIndex * 100}%)`;
  }

  innerTrack.addEventListener('transitionend', () => {
    isTransitioning = false;

    if (currentTrackIndex >= totalSlides + 1) {
      // If we went past the last slide clone, snap instantly to the real first slide
      innerTrack.style.transition = 'none';
      currentTrackIndex = 1;
      innerTrack.style.transform = `translateX(-${currentTrackIndex * 100}%)`;
    } else if (currentTrackIndex <= 0) {
      // If we went past the first slide clone backward, snap instantly to the real last slide
      innerTrack.style.transition = 'none';
      currentTrackIndex = totalSlides;
      innerTrack.style.transform = `translateX(-${currentTrackIndex * 100}%)`;
    }
  });

  // 3. Button Events
  const prevBtn = carouselContainer.querySelector('#simple-carousel-prev');
  const nextBtn = carouselContainer.querySelector('#simple-carousel-next');

  if (prevBtn) prevBtn.addEventListener('click', () => moveSlide(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => moveSlide(1));

  // 4. Mobile Touch/Swipe Event Handlers
   // 6. Mobile Touch Support
  let touchStartX = 0;
  let touchEndX = 0;

  innerTrack.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches.clientX;
  }, { passive: true });

  innerTrack.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches.clientX;
    const swipeDistance = touchStartX - touchEndX;
    if (swipeDistance > 50) moveSlide(1);
    else if (swipeDistance < -50) moveSlide(-1);
  }, { passive: true });
 
}